import { useRef } from 'react';

export const useScrollbar = (ref?: HTMLElement | null) => {
  const scrollbarRef = useRef<HTMLElement>(
    ref ?? document.getElementById('main-scroller')
  );

  const getCurrentPosition = (): ScrollPosition => {
    return {
      left: scrollbarRef.current?.scrollLeft,
      top: scrollbarRef.current?.scrollTop,
    };
  };

  const scrollToPosition = (options: ScrollToOptions) => {
    if (scrollbarRef) scrollbarRef.current?.scrollTo(options);
  };

  const scrollToTop = (behavior?: ScrollBehavior) => {
    if (scrollbarRef)
      scrollbarRef.current?.scrollTo({ top: 0, left: 0, behavior: behavior });
  };

  return {
    getCurrentPosition,
    scrollbarRef,
    scrollToTop,
    scrollToPosition,
  };
};
